import React from 'react';
import { scrollToCompra } from '../utils/scroll';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
  className?: string;
  pulse?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  pulse = true,
  fullWidth = true
}: ButtonProps) {
  // Green background (#22C55E), white text, darker green shadow (#15803D)
  const baseClasses = 'relative inline-flex items-center justify-center font-montserrat font-black text-white bg-brand-accent hover:bg-brand-accentDark transition-all duration-300 rounded-lg shadow-[0_4px_0_#15803D] hover:shadow-[0_2px_0_#15803D] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] px-4 py-3 md:px-6 md:py-4 text-base md:text-lg lg:text-xl text-center uppercase tracking-wide';
  const pulseClasses = pulse ? 'animate-pulse-fast' : '';
  const widthClasses = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e);
    } else if (!href) {
      scrollToCompra(e);
    }
  };
  if (href) {
    return <a href={href} className={`${baseClasses} ${pulseClasses} ${widthClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-44">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${pulseClasses} ${widthClasses} ${className}`} data-id="element-45">
      {children}
    </button>;
}